<template>
  <div>
    <v-head></v-head>
    <div class="infor_bg">
      <img src="../assets/pic02.png" alt="">
      <div class="infor_txt">
        <div class="title">
          物联网
        </div>
        <div class="txt">
          Internet of Things
        </div>
      </div>
    </div>
    
    <div class="infor_content">
      <div class="content" @click="gotoMoreInfor">
        <div class="content_wrap">
          <p class="title">基于物联网的设备管理平台</p>
          <img src="../assets/pic11.png" alt="">
          <div class="right_txt">
            <span>了解更多</span>
            <span class="el-icon-right"></span>
          </div>
        </div>
      </div>
      
    </div>
    
    <v-foot class="infor_foot"></v-foot>
    
  </div>
</template>
<script>
import router from '../router/index.js'
export default {
  methods: {
    gotoHome() {
      router.push('/')
    },
    gotoMoreInfor() {
      router.push('/moreInfor4')
    }
  }
}
</script>
<style scoped>

.head {
  position: absolute;
  background-color: #000;
  height: 75px;
  top: 0;
  width: 100%;
}
.head img {
  margin-top: 10px;
  width: 55px;
  height: 57px;
  margin-left: 20px;
}
.infor_bg img {
  margin-top: 75px;
  width: 100%;  
  height: 600px;  
}
.infor_txt {
  position: absolute;
  top: 260px;
  right: 420px;
  color: #fff ;
}
.infor_txt .title {
  font-size: 58px;
}
.infor_txt .txt {
  margin-top: 32px;
  font-size: 32px;
}
.infor_text {
  display: flex;
}
.infor_content {
  display: flex;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  margin-top: 70px;
}
.infor_content .content {
  background-color: #fff;
  border: 1px solid #dee;
  box-shadow: 1px 1px 1px 1px #eee;

  padding: 30px 50px;
  margin-right: 100px;

}
.infor_content .title {
  font-size: 20px;
  color: #333;
  font-weight: 600;
}
.infor_content img {
  margin-top: 20px;
  width: 370px;
  height: 180px;
}
.infor_content .right_txt {
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
  width: 370px;
  font-size: 15px;
  color: #999;
}
.infor_content .el-icon-right {
  font-size: 20px;
}
.infor_content1 {
  display: flex;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  margin-top: 435px;
}
.infor_content1 .content {
  background-color: #fff;
  border: 1px solid #dee;
  box-shadow: 1px 1px 1px 1px #eee;
  padding: 30px 50px;
  margin-right: 100px;

}
.infor_content1 .title {
  font-size: 20px;
  font-weight: 600;
  color: #333;
}
.infor_content1 img {
  margin-top: 20px;
  width: 370px;
  height: 180px;
}
.infor_content1 .right_txt {
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
  width: 370px;
  font-size: 15px;
  color: #999;
}
.infor_content1 .el-icon-right {
  font-size: 20px;
}
.infor_foot {
  position: relative;
  margin-top: 520px;
}
.infor_content .last {
  margin-right: 0;
}
.infor_content1 .last {
  margin-right: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/Information1.vue